import https from "../http-common";
class ShelterDataService {
    getAllShelters(requestPayload: ShelterPayload) {
        return https.get("/shelter", { params: requestPayload });
    }
}
export default new ShelterDataService();